import { Sheet, SheetContent, SheetTitle } from '@/components/ui/sheet';
import { useGlobalMenuSheet, usePlayerlistSheet } from '@/hooks/sheets';
import FcNavigation from './FcNavigation';
import { PlayerlistSidebar } from './PlayerlistSidebar/PlayerlistSidebar';

function NavigationDrawer() {
    const { isSheetOpen, setIsSheetOpen } = useGlobalMenuSheet();
    return (
        <Sheet open={isSheetOpen} onOpenChange={setIsSheetOpen}>
            <SheetContent side="left" className="fc-drawer-content p-0">
                <SheetTitle className="sr-only">FC Admin Navigation</SheetTitle>
                <FcNavigation drawer />
            </SheetContent>
        </Sheet>
    );
}

function PlayerDrawer() {
    const { isSheetOpen, setIsSheetOpen } = usePlayerlistSheet();
    return (
        <Sheet open={isSheetOpen} onOpenChange={setIsSheetOpen}>
            <SheetContent side="right" className="fc-drawer-content p-0">
                <SheetTitle className="sr-only">Online-Spieler</SheetTitle>
                <PlayerlistSidebar isSheet />
            </SheetContent>
        </Sheet>
    );
}

export default function MainSheets() {
    return <><NavigationDrawer /><PlayerDrawer /></>;
}
